module.exports = __webpack_public_path__ + "img/CC9A7E_8A5249_C06A3E_DADADA-256px.7c7113d4.png";